import { useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2, Users } from "lucide-react";
import { useForumMembersQuery } from "../api/forumApi";

/**
 * The committee as it stands today.
 *
 * Worth a screen of its own because the membership is not a list anybody
 * maintains — it is derived from the offices held right now, and the only
 * way to see who that actually is, is to ask.
 */
export default function ForumMembersPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useForumMembersQuery();

  return (
    <div className="p-4 md:p-6 max-w-3xl mx-auto">
      <button
        type="button"
        onClick={() => navigate("/forum")}
        className="inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.15em] text-gray-400 hover:text-gray-600 mb-5"
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        Back to the forum
      </button>

      <div className="flex items-center gap-2.5 mb-2">
        <div className="w-9 h-9 rounded-2xl bg-gray-900 flex items-center justify-center">
          <Users className="w-4 h-4 text-white" />
        </div>
        <h1 className="text-xl font-black text-gray-900 tracking-tight">
          Who is in this forum
        </h1>
      </div>
      <p className="text-xs text-gray-500 mb-6 max-w-xl leading-relaxed">
        {data?.total ?? 0} people. Nobody is enrolled here — the committee is
        whoever is serving in a national position today, plus the chapter
        chairmen who sit on it ex officio. When an office changes hands, this
        list changes with it.
      </p>

      {isLoading ? (
        <div className="flex items-center justify-center py-20 text-gray-300">
          <Loader2 className="w-5 h-5 animate-spin" />
        </div>
      ) : (
        <div className="space-y-4">
          {(data?.groups ?? []).map((group) => (
            <div
              key={group.group}
              className="rounded-2xl border border-gray-100 bg-white overflow-hidden shadow-sm"
            >
              <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
                <span className="text-[10px] font-black uppercase tracking-[0.15em] text-gray-500">
                  {group.label}
                </span>
                <span className="text-[10px] font-bold text-gray-400 ml-2">
                  {group.people.length}
                </span>
              </div>
              <div className="divide-y divide-gray-50">
                {group.people.map((person, i) => (
                  <div key={`${person.name}-${i}`} className="px-5 py-3">
                    <div className="text-sm font-bold text-gray-800 truncate">
                      {person.name}
                    </div>
                    <div className="text-[10px] font-bold text-gray-400 truncate">
                      {person.seat}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
